<template>
  <div>
    <Tab
      :tablist="list"
      @change="changeTab"
      @constDetail="openConstDetailPop"
      @accountDetail="openAccountDetailPop"
      @serverDialog="openServerDialog"
      :tabCurrent="current"
    />
    <Content
      v-for="(item, index) in list"
      v-if="index == current"
      :key="index"
      :tabContent="item"
      :isSearching="isSearching"
      @search="searchId"
    />
    <Table
      :data="tableDatas"
      :sureflag="isSureDownload"
      :downflag="isDownloading"
      :clearflag="isClearFlag"
      :netError="isNetError"
      v-if="showTable"
      v-loading="tableLoading"
      @noBanlance="noBanlances"
      @onDownload="downloadId"
      @onSureDown="changeDown"
      @chanegV3="changeTab"
    />
    <Dialog
      :dialogVisible="dialogTableVisible"
      @closeDialog="closeConstDetailPop"
    />
    <Accountdialog
      :dialogVisible="accountDialogTableVisible"
      @closeDialog="closeAccountDetailPop"
    />
    <Serverdialog
      :dVisible="serverDialogVisible"
      @closeDialogs="closeServerDialod"
    />
  </div>
</template>

<script>
import Tab from "./module/tab.vue";
import Table from "./module/table.vue";
import Content from "./module/content.vue";
import { searchImage, getShutterStatus } from "@/api/downLoad";
import { message } from "@/utils/resetMessage";
import Dialog from "./module/dialog.vue";
import Accountdialog from "./module/accountdialog";
import Serverdialog from "./module/serverdialog";
import { checkStatus } from "@/utils/checkout";

// 图片类型配置映射
const PIC_TYPE_MAP = new Map([
  [0, { value: 0, label: "JPG" }],
  [1, { value: 1, label: "ait" }],
  [2, { value: 2, label: "indt" }],
  [3, { value: 3, label: "psdt" }],
  [4, { value: 4, label: "EPS" }],
  [10, { value: 10, label: "svg" }],
  [11, { value: 11, label: "ai" }],
  [12, { value: 12, label: "mdl" }],
  [13, { value: 13, label: "wav" }],
]);

// 视频类型配置
const VIDEO_TYPE_CONFIG = {
  0: { options: [{ value: 0, label: "HD" }], label: "HD", webType: "video" },
  1: {
    options: [
      { value: 0, label: "HD" },
      { value: 1, label: "4K" },
    ],
    label: "HD",
    webType: "video",
  },
  2: {
    options: [{ value: 2, label: "SelectHD" }],
    label: "SelectHD",
    webType: "videoyx",
    priceIndex: 2,
  },
  3: {
    options: [
      { value: 2, label: "SelectHD" },
      { value: 3, label: "Select4K" },
    ],
    label: "SelectHD",
    webType: "videoyx",
    priceIndex: 2,
  },
};

// 余额限制配置
const BALANCE_LIMITS = [
  { max: 50, limit: 30, message: "You can only search up to 30 IDS at a time" },
  { max: 100, limit: 70, message: "You can only search up to 70 IDS at a time" },
];

// 错误消息配置
const ERROR_CONFIG = {
  network: {
    message: "Network exception, please try again",
    showClose: true,
    duration: 4000,
    offset: 100,
  },
  login: {
    message: "Please log in",
    showClose: true,
    duration: 4000,
    offset: 100,
  },
};

// 创建默认表单数据
const createDefaultDataForm = () => ({
  img: "",
  id: "",
  imgSize: "",
  complete: false,
  loading: false,
  saleType: "",
  price: 0,
  priceList: [],
  videoType: 0,
  isfk: false,
  isyx: false,
  orgPrice: "",
  balance: "",
  value: 4,
  disabled: false,
  videoValue: 0,
  videoLabel: "",
  videoDisabled: false,
  videoOptions: [],
  options: [],
  webType: "",
  downurl: "",
  downurl2: "",
  type: true,
  showType: true,
  isBuy: false,
  msg: "",
  error: false,
  isVideo: false,
  isBuy1: false,
  isCos: false,
  checking: false,
  isChange: false,
  showButton: false,
  errorIcon: "",
  title: "",
  videoSize: "",
});

export default {
  name: "MaterialDownload",
  components: {
    Accountdialog,
    Tab,
    Table,
    Content,
    Dialog,
    Serverdialog,
  },
  data() {
    return {
      getAll_status: 0,
      isLoggedIn: false,
      current: 0,
      webType: "shutterstock_V2",
      list: [
        {
          title: "shutterstock",
          subTitle: "shutterstock",
          titleState: "success",
          tip: '<ul><li>The 10-digit number ID starting with 223 cannot be downloaded (for example: 2236071928). Please contact our customer service team for price inquiry.</li><li>If the picture ID indicates that it has been taken off the shelf, it means that the picture has been removed and cannot be downloaded on the entire website.</li> <li>The batch download function can be turned on by enable \'allow web page pop-ups\' (each browser has a different setting method, please search by yourself).</li> <li>Due to recent restrictions on Shutterstock, some links may not download properly. If you are unable to download Shutterstock images, please use the V2 channel to proceed with your download. </li> </ul>',
          label: null,
          webType: "shutterstock_V2",
          icon: require("@/assets/images/download/ic1_1.png"),
          status: true,
        },
        {
          title: "shutterstock_v2",
          subTitle: "shutterstock_v2",
          titleState: "success",
          tip: '<ul><li>V2 is a second channel provided for customers who need urgent access.</li> <li>Due to recent restrictions on the Shutterstock official website, some links may not download properly. We sincerely apologize and are working hard to resolve this issue.</li> <li> If you are unable to download Shutterstock images. Please send the links to us via WhatsApp. <a href="https://wa.me/60146695645/" target="_blank"> https://wa.me/60146695645/ </a></li></ul>',
          label: null,
          webType: "shutterstock_V3",
          icon: require("@/assets/images/download/ic1_1.png"),
          status: true,
        },
        {
          title: "AdobeStock",
          subTitle: "",
          titleState: "success",
          tip: "<ul><li>Some Adobe images cannot be downloaded if the LICENSE TYPE is Enhanced. If you would like to download, please contact our customer service team (price of enhanced license image is higher than standard license image).</li><li>Please contact our customer service team for price enquiry if you wish to download Adobe video, music, etc.</li></ul>",
          label: null,
          webType: "adobestock",
          icon: require("@/assets/images/download/ic8_8.png"),
          status: true,
        },
        {
          title: "AdobeStock Video",
          subTitle: "",
          titleState: "success",
          tip: "<ul><li>The price of AdobeStock video is different from that of 4K video. Please confirm the unit price before downloading </li> <li>If the video ID prompts you to get off the shelf, please contact the customer service for processing. The video can be downloaded </li><li>The video only provides 12 hours of storage time. If the video is not downloaded in time, the fee will be deducted twice. If the video is not downloaded or there is a problem, please contact the WeChat customer service above in time to deal with it</li></ul>",
          label: null,
          isPop: false,
          webType: "vadobestock",
          icon: require("@/assets/images/download/ic8_8.png"),
          status: true,
        },
        {
          title: "iStockphoto",
          subTitle: "",
          tip: "<ul><li>Please copy and paste the image ID number to download istockphoto if the image URL is not recognized by the system.</li></ul>",
          titleState: "success",
          label: null,
          webType: "istockphoto",
          icon: require("@/assets/images/download/ic5_5.png"),
          status: true,
        },
        {
          title: "iStockphoto Video",
          subTitle: "",
          titleState: "success",
          tip: "<ul><li>The price of iStockphoto video is different from that of 4K video. Please confirm the unit price before downloading </li> <li>If the video ID prompts you to get off the shelf, please contact the customer service for processing. The video can be downloaded </li><li>The video only provides 12 hours of storage time. If the video is not downloaded in time, the fee will be deducted twice. If the video is not downloaded or there is a problem, please contact the WeChat customer service above in time to deal with it</li></ul>",
          label: null,
          isPop: false,
          webType: "vistockphoto",
          icon: require("@/assets/images/download/ic5_5.png"),
          status: true,
        },
        {
          title: "Depositphotos",
          subTitle: "",
          titleState: "success",
          label: null,
          webType: "depositphotos",
          icon: require("@/assets/images/download/ic2_2.png"),
          status: true,
        },
        {
          title: "Dreamstime",
          subTitle: "",
          titleState: "success",
          label: null,
          webType: "dreamstime",
          icon: require("@/assets/images/download/ic6_6.png"),
          status: true,
        },
        {
          title: "123rf",
          subTitle: "",
          titleState: "success",
          label: null,
          webType: "rfoto",
          icon: require("@/assets/images/download/ic3_3.png"),
          status: true,
        },
        {
          title: "vectorstock",
          subTitle: "",
          titleState: "success",
          label: null,
          webType: "vectorstock",
          icon: require("@/assets/images/download/ic11_11.png"),
          status: true,
        },
        {
          title: "freepik",
          subTitle: "",
          tip: "<ul><li>Please copy and paste the image ID number to download Freepik photo, the ID number is the number in front of the URL's htm.</li></ul>",
          titleState: "success",
          label: null,
          webType: "freepik",
          icon: require("@/assets/images/download/ic10_10.png"),
          status: true,
        },
        {
          title: "Alamy",
          subTitle: "",
          tip: "<ul><li>Please copy the image ID on the website page to download, such as image ID: d2i95c</li><li>Alamy only provides JPG format, not vector format, please download as needed</li></ul>",
          titleState: "success",
          label: null,
          isPop: false,
          webType: "alamy",
          icon: require("@/assets/images/download/alamy.png"),
          status: true,
        },
        {
          title: "Pixelsquid",
          subTitle: "",
          tip: "<ul><li>Please copy the ID on the website page to download, such as: https://www.pixelsquid.com/png/retro-car-white-2337168235838838579 , then 2337168235838838579 is the material ID. enter the material ID to download</li></ul>",
          titleState: "success",
          label: null,
          webType: "pixelsquid",
          isPop: false,
          icon: require("@/assets/images/download/pixelsquid.png"),
          status: true,
        },
        {
          title: "Envato Elements",
          subTitle: "",
          tip: "<ul><li>Please copy and paste the url ID to download Envato Element, the url ID is the last seven letters. For example: https://elements.envato.com/flowchart-VXTQBRF, then VXTQBRF is the url ID. Enter the url ID to download.</li></ul>",
          titleState: "success",
          label: null,
          webType: "envatoelements",
          isPop: false,
          icon: require("@/assets/images/download/elements.png"),
          status: true,
        },
        {
          title: "S.S video",
          subTitle: "",
          titleState: "success",
          tip: "<ul><li>The price of Shutterstock Select video is different from that of 4K video. Please confirm the unit price before downloading. </li> <li>If the video ID prompts to be unavailable, please contact our customer service team, all videos can be downloaded.</li></ul>",
          label: null,
          webType: "video",
          icon: require("@/assets/images/download/ic1_1.png"),
          status: true,
        },
        {
          title: "S.S music",
          subTitle: "",
          titleState: "success",
          isPop: false,
          tip: "<ul><li>If the music ID prompts for removal, please contact customer service for processing. shutterstock music can be downloaded</li><li>Music only provides 6 hours of storage time. If not downloaded in a timely manner, a second fee will be deducted. If the download does not work or there are problems, please contact the WeChat customer service above in a timely manner for handling</li></ul>",
          label: null,
          webType: "music",
          icon: require("@/assets/images/download/ic1_1.png"),
          status: true,
        },
        {
          title: "motionarray",
          subTitle: "",
          titleState: "success",
          label: null,
          webType: "motionarray",
          icon: require("@/assets/images/download/ic_12.jpg"),
          status: true,
        },
        {
          title: "vecteezy",
          subTitle: "",
          titleState: "success",
          label: null,
          webType: "vecteezy",
          icon: require("@/assets/images/download/ic_13.jpg"),
          status: true,
        },
      ],
      tableDatas: [],
      showTable: false,
      tableLoading: false,
      dialogTableVisible: false,
      accountDialogTableVisible: false,
      serverDialogVisible: false,
      form: {
        webType: "",
        imageID: "",
      },
      dataForm: createDefaultDataForm(),
      timer: null,
      isSearching: false,
      searchCount: 0,
      isDownloading: false,
      isSureDownload: false,
      isClearFlag: false,
      isNetError: false,
    };
  },
  mounted() {
    this.isLoggedIn = !!(
      this.$store.state.user.token &&
      this.$store.state.user.loginNameType != null
    );

    this.$EventBus.$on("constDetailOut", this.openConstDetailPop);
    this.$EventBus.$on("accountDetailOut", this.openAccountDetailPop);

    this.getStatus();
    this.initTawkChat();
    checkStatus();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    this.timer = null;
    this.$EventBus.$off("constDetailOut", this.openConstDetailPop);
    this.$EventBus.$off("accountDetailOut", this.openAccountDetailPop);
  },
  methods: {
    // 初始化 Tawk 聊天
    initTawkChat() {
      const userInfo = this.$store.state.common.userInfo;
      const userName = userInfo.mobile || "";
      const userEmail = userInfo.mail || (userName ? `${userName}@gestocks.com` : "");

      if (typeof tawks1 !== "undefined" && tawks0) {
        tawks0.parentNode.insertBefore(tawks1, tawks0);
      }

      // 设置访客信息
      if (typeof Tawk_API !== "undefined" && userEmail) {
        Tawk_API.visitor = {
          email: userEmail,
        };
      }

      // Google Analytics
      window.dataLayer = window.dataLayer || [];
      const gtag = (...args) => dataLayer.push(args);
      gtag("js", new Date());
      gtag("config", "UA-78962210-9");
    },

    // 获取 tab 状态
    async getStatus() {
      const statusMap = {
        adobestock: "adobestock",
        istockphoto: "istockphoto",
        dreamstime: "dreamstime",
        vistockphoto: "vistockphoto",
        "123RF": "123RF",
        vectorstock: "vectorstock",
        Alamy: "alamy",
      };

      const fetchStatus = async () => {
        try {
          const res = await getShutterStatus();
          const data = JSON.parse(res);
          Object.entries(statusMap).forEach(([key, webType]) => {
            this.setTabStatus(data[key], webType);
          });
        } catch (e) {
          // 静默处理错误
        }
      };

      await fetchStatus();
      this.timer = setTimeout(fetchStatus, 60000);
    },

    // 设置 tab 状态 - 优化后的查找逻辑
    setTabStatus(data, name) {
      const target = this.list.find((item) => item.webType === name);
      if (target) {
        target.status = data === "online";
      }
    },

    // 切换 tab
    changeTab(index) {
      this.current = index;
      this.webType = (this.list[this.current] && this.list[this.current].webType) || "shutterstock_V2";
      this.tableDatas = [];
      this.isSearching = false;
      this.isSureDownload = false;
      this.showTable = false;
      this.tableLoading = false;
      this.dialogTableVisible = false;
      this.accountDialogTableVisible = false;
    },

    // 打开客服下载提示
    openServerDialog() {
      this.serverDialogVisible = true;
    },
    closeServerDialod() {
      this.serverDialogVisible = false;
    },

    // 费用明细
    openConstDetailPop() {
      this.dialogTableVisible = true;
    },
    closeConstDetailPop() {
      this.dialogTableVisible = false;
    },

    // 余额明细
    openAccountDetailPop() {
      this.accountDialogTableVisible = true;
    },
    closeAccountDetailPop() {
      this.accountDialogTableVisible = false;
    },

    // 获取表格数据 - 优化后的逻辑
    getTableDatas(result) {
      const dataForm = createDefaultDataForm();
      dataForm.webType = this.webType;
      if (result.status === 0) {
        this.assignSuccessData(dataForm, result);
      } else {
        dataForm.id = result.recCode;
        dataForm.msg = result.msg;
        dataForm.type = false;
      }
      this.tableDatas.push(dataForm);
      this.tableLoading = false;
    },

    // 赋值成功数据
    assignSuccessData(dataForm, result) {
      const { searchDTO, detailJson, webType } = result;

      Object.assign(dataForm, {
        img: result.iconUrl,
        id: result.recCode,
        price: result.price,
        orgPrice: result.orgPrice,
        isVideo: false,
        isCos: (detailJson[0] && detailJson[0].isCos) || false,
        isBuy: (detailJson[0] && detailJson[0].isBuy) || false,
        isBuy1: (detailJson[0] && detailJson[0].isBuy1) || false,
        msg: (detailJson[0] && detailJson[0].isBuy) ? "free" : "",
      });

      // 图片类型处理
      this.assignPicType(dataForm, searchDTO.picType, webType || this.webType);

      // 音乐类型处理
      if ((webType || this.webType) === "music") {
        dataForm.title = searchDTO.title;
        dataForm.videoSize = searchDTO.vedioSize;
        dataForm.isVideo = true;
      }

      // 视频类型处理
      if (this.isVideoType(webType || this.webType)) {
        this.assignVideoData(dataForm, result, webType || this.webType);
      }
    },

    // 判断是否为视频类型
    isVideoType(webType) {
      return ["video", "vedio", "vistockphoto", "vadobestock"].some((type) =>
        webType.includes(type)
      );
    },

    // 赋值图片类型
    assignPicType(dataForm, picType, webType) {
      if (picType === 9) {
        dataForm.showType = false;
        return;
      }
      
      const config = PIC_TYPE_MAP.get(picType);
      if (config) {
        dataForm.value = config.value;
        dataForm.options = [config];

        if (picType === 0 && webType !== "music") {
          dataForm.imgSize = "";
        }
      }
    },

    // 赋值视频数据
    assignVideoData(dataForm, result, webType) {
      const { searchDTO, detailJson, priceList, videoType } = result;

      dataForm.isVideo = true;
      dataForm.value = searchDTO.picType;
      dataForm.priceList = priceList;
      dataForm.isyx = (detailJson[0] && detailJson[0].yxflag) || false;
      dataForm.isfk = (detailJson[0] && detailJson[0].fkflag) || false;
      dataForm.videoType = videoType;

      // 视频格式选项
      dataForm.options =
        searchDTO.picType === 5
          ? [{ value: 5, label: "MOV" }]
          : [{ value: 6, label: "MP4" }];

      // 视频类型配置
      const config = VIDEO_TYPE_CONFIG[videoType];
      if (config) {
        dataForm.videoOptions = config.options;
        dataForm.videoLabel = config.label;
        dataForm.videoValue = (config.options[0] && config.options[0].value) || 0;

        // 设置 webType
        if (webType.includes("vistockphoto")) {
          dataForm.webType = "vistockphoto";
        } else if (webType.includes("vadobestock")) {
          dataForm.webType = "vadobestock";
        } else {
          dataForm.webType = config.webType;
        }

        // 严选视频价格
        if (config.priceIndex !== undefined && priceList[config.priceIndex]) {
          dataForm.price = priceList[config.priceIndex].price;
        }
      }
    },

    // 下载状态
    downloadId(flag) {
      this.isSearching = flag;
      this.isDownloading = flag;
    },

    // 改变下载状态
    changeDown(flag) {
      this.isSureDownload = flag;
    },

    // 检查余额限制
    checkBalanceLimit(balance, paramsLength) {
      for (const limit of BALANCE_LIMITS) {
        if (balance <= limit.max && paramsLength > limit.limit) {
          message.error({
            message: limit.message,
            showClose: true,
            duration: 4000,
            offset: 100,
          });
          return false;
        }
      }
      return true;
    },

    // 搜索 ID - 优化后的并行请求
    async searchId(prams) {
      if (!this.isLoggedIn) {
        message.error(ERROR_CONFIG.login);
        return;
      }

      const balance = this.$store.state.common.userInfo.blance;
      if (!this.checkBalanceLimit(balance, prams.length)) {
        this.downloadId(false);
        this.showTable = false;
        this.tableLoading = false;
        return;
      }

      this.isSearching = true;
      this.isClearFlag = true;
      this.isDownloading = true;
      this.isSureDownload = false;
      this.tableDatas = [];
      this.showTable = true;
      this.tableLoading = true;

      try {
        // 串行请求改为并行请求，提高性能
        const batchSize = 5; // 每批5个请求
        for (let i = 0; i < prams.length; i += batchSize) {
          const batch = prams.slice(i, i + batchSize);
          await Promise.all(
            batch.map((imageID) => this.searchSingleImage(imageID))
          );
        }
      } finally {
        this.isSearching = false;
        this.isDownloading = false;
        this.isClearFlag = false;
        this.tableLoading = false;
      }
    },

    // 搜索单个图片
    async searchSingleImage(imageID) {
      const dataform = {
        webType: this.webType,
        imageID,
      };

      try {
        let res = await searchImage(dataform);
        console.log("222222"+JSON.stringify(res))
        // 重试一次
        if (!(res && res.recCode)) {
          res = await searchImage(dataform);
        }

        if (res && res.recCode) {
          console.log("1111111"+JSON.stringify(res))
          this.isNetError = false;
          this.getTableDatas(res);
        } else {
          throw new Error("Empty response");
        }
      } catch (e) {
        this.isNetError = true;
        message.error(ERROR_CONFIG.network);
      }

      this.tableLoading = this.tableDatas.length === 0;
    },

    // 余额不足
    noBanlances() {
      this.tableDatas = [];
      this.isSureDownload = false;
    },
  },
};

// Tawk 脚本初始化
let tawks1, tawks0;
(function () {
  tawks1 = document.createElement("script");
  tawks0 = document.getElementsByTagName("script")[0];
  tawks1.async = true;
  tawks1.src = "https://embed.tawk.to/6106177fd6e7610a49adf823/1fbvsnjjk";
  tawks1.charset = "UTF-8";
  tawks1.setAttribute("crossorigin", "*");
  tawks0.parentNode.insertBefore(tawks1, tawks0);
})();
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
::v-deep li {
  list-style: initial !important;
}
::v-deep ul {
  padding: 0 10px;
}
</style>
